import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { CountdownTimer } from './CountdownTimer';
import { bonusValue, brandName, discount, fullPrice, included, price, volumesValue } from '../data/copy';
export function OfferSection() {
  return <section id="oferta" className="defer-paint w-full scroll-mt-6 bg-canvas py-12 sm:py-16" aria-labelledby="offer-heading" data-id="element-119" data-mp="de58panb70ny">
      <div className="mx-auto max-w-5xl px-6" data-id="element-120" data-mp="idzvp33yr63q">
        <div className="mx-auto max-w-2xl text-center" data-id="element-121" data-mp="ifazh2xesduu">
          <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-accent" data-id="element-122" data-mp="mdsahxjya8hj">La tua offerta di lancio oggi</p>
          <h2 id="offer-heading" className="mt-4 font-serif text-[2.2rem] font-bold leading-[1.05] text-ink sm:text-[2.6rem]" data-id="element-123" data-mp="repsa911t0ii">
            {brandName}
          </h2>
          <p className="mt-3 font-sans text-base leading-relaxed text-muted" data-id="element-124" data-mp="2t6b5sds3vrjy">
            Kit completo + 5 bonus strategici.
          </p>
        </div>

        <div className="mt-9 grid gap-6 lg:grid-cols-[1fr_1.1fr] lg:gap-8" data-id="element-125" data-mp="12nibngvv83rd">
          <div className="space-y-6" data-id="element-126" data-mp="12oti5ogp3pm6">
            <div className="rounded-3xl border border-line bg-card p-6 sm:p-7" data-id="element-127" data-mp="xx1vhp0nu41b">
              <p className="font-sans text-[11px] font-semibold uppercase tracking-[0.22em] text-muted" data-id="element-128" data-mp="sxp0ggzmxqnn">Cosa stai ricevendo oggi</p>
              <ul className="mt-5 divide-y divide-line" data-id="element-129" data-mp="owwqtmmupjqu">
                <li className="flex items-baseline justify-between gap-4 py-3 font-sans text-[0.9rem] text-ink" data-id="element-130" data-mp="ouaivlw1t283">
                  <span data-id="element-131" data-mp="1gn9v3x55iccr">
                    <span className="block font-semibold" data-id="element-132" data-mp="1gn1kyd0exl59">6 volumi · 70+ lezioni</span>
                    <span className="mt-0.5 block text-[0.8rem] text-muted" data-id="element-133" data-mp="1cl6iv6anr3qf">
                      Vinyasa, Hatha, Yin, Posturale, Pranayama, Emergenza
                    </span>
                  </span>
                  <span className="shrink-0 text-muted" data-id="element-134" data-mp="172h3dxtwbat">{volumesValue}</span>
                </li>
                <li className="flex items-baseline justify-between gap-4 py-3 font-sans text-[0.9rem] text-ink" data-id="element-135" data-mp="3scaudb0tbpqg">
                  <span data-id="element-136" data-mp="3ttpxg821xjc6">
                    <span className="block font-semibold" data-id="element-137" data-mp="3tuiycsebxeme">5 bonus strategici</span>
                    <span className="mt-0.5 block text-[0.8rem] text-muted" data-id="element-138" data-mp="2mdi7ykqbfyw">
                      Inclusi oggi senza costi aggiuntivi
                    </span>
                  </span>
                  <span className="shrink-0 text-muted" data-id="element-139" data-mp="3ou5185e9np35">{bonusValue}</span>
                </li>
              </ul>
              <div className="mt-4 flex items-baseline justify-between gap-4 border-t border-accent/30 pt-4" data-id="element-140" data-mp="3b2q5cxz9fteo">
                <span className="font-sans text-[11px] font-semibold uppercase tracking-[0.16em] text-accent" data-id="element-141" data-mp="3fvt2fg38xkzm">
                  Valore totale della libreria
                </span>
                <span className="font-serif text-4xl font-bold leading-none text-accent" data-id="element-142" data-mp="365gi9ozcftu0">
                  {fullPrice}
                </span>
              </div>
            </div>

            <CountdownTimer data-id="element-143" data-mp="2x48ljbch7121" />
          </div>

          <div className="rounded-3xl border border-accent/30 bg-card p-6 text-center shadow-xl shadow-accent/10 sm:p-9" data-id="element-144" data-mp="2x2xijdqutxbz">
            <p className="flex items-center justify-center gap-3 font-sans text-sm text-muted" data-id="element-145" data-mp="2djrw2l153bu3">
              <span data-id="element-146" data-mp="28l6xsr5g728a">
                Valore: <span className="line-through" data-id="element-147" data-mp="2mj4zavyo746d">{fullPrice}</span>
              </span>
              <span className="rounded-full bg-accent px-2.5 py-0.5 font-sans text-[11px] font-bold uppercase tracking-[0.1em] text-white" data-id="element-148" data-mp="2ih9xzrgqoqsl">
                {discount} di sconto
              </span>
            </p>
            <p className="mt-2 flex items-start justify-center gap-1 font-serif font-bold leading-none text-ink" data-id="element-149" data-mp="2ri84cgenhaec">
              <span className="mt-3 text-3xl text-accent" data-id="element-150" data-mp="365kr28g71m6b">€</span>
              <span className="text-[5.5rem] leading-none sm:text-[6.5rem]" data-id="element-151" data-mp="317jd21xmkd1p">19</span>
            </p>
            <p className="mt-2 font-sans text-xs text-muted" data-id="element-152" data-mp="3f713elqkjyd6">
              Pagamento unico · prezzo di lancio
            </p>

            <ul className="mt-6 grid grid-cols-2 gap-x-4 gap-y-2.5 border-t border-line pt-5 text-left" data-id="element-153" data-mp="3a8zbdbb60opk">
              {included.map(item => <li key={item} className="flex items-center gap-2 font-sans text-[0.84rem] leading-snug text-ink" data-id="element-154" data-mp="18iij13tstd76">
                  <CheckIcon className="h-3.5 w-3.5 shrink-0 text-accent" strokeWidth={2.6} aria-hidden="true" data-id="element-155" data-mp="1dg0je5tr2k3k" />
                  {item}
                </li>)}
            </ul>

            <CtaButton size="large" className="mt-7 w-full" data-id="element-156" data-mp="1m9x55jj05uig">
              Accedi ora — {price}
            </CtaButton>

            <p className="mt-4 text-center font-sans text-[11px] text-muted" data-id="element-157" data-mp="pm90o4bv60hd">
              Pagamento sicuro · accesso immediato · garanzia di 7 giorni
            </p>
          </div>
        </div>
      </div>
    </section>;
}